<template>
  <div>
    <Headline
      :title="title"
      subtitle="¿Nuestra ambición? Dejar recuerdos para toda la vida"
      third-text='Compartimos con nuestros clientes la ambición del factor "WOW".'
      image="groups"
    ></Headline>
    <Section image="groups-1">
      <Card
        title="Lo que ofrecemos"
        size="lg"
        variant="list"
      >
        <ul>
          <li>Creación del concepto</li>
          <li>Gama ampliada de servicios</li>
          <li>Equipo de profesionales de alto nivel</li>
          <li>Soluciones a medida</li>
          <li>Conocimiento del destino</li>
          <li>Servicio personalizado</li>
        </ul>
      </Card>
      <Card
        title="Lo que garantizamos"
        size="lg"
        variant="list"
      >
        <ul>
          <li>Planificación y desarrollo de viajes</li>
          <li>Comunicación a los participantes</li>
          <li>Selección de servicios</li>
          <li>Lugares de interés</li>
          <li>Documentación y visados</li>
          <li>Seguimiento por un especialista</li>
          <li>Medición del éxito</li>
        </ul>
      </Card>
    </Section>
    <Section image="groups-2">
      <Card
        title="HACER LO IMPOSIBLE"
        size="lg"
      >Tanto si se trata de recompensar a los socios como de motivar a los empleados, perpetuar el recuerdo de un viaje inolvidable es la mejor manera de crear relaciones sólidas.</Card>
    </Section>
  </div>
</template>
<script setup>
definePageMeta({
  title: 'Grupos e incentivos',
  path: '/servicios/grupos-e-incentivos',
})
const title = useRoute().meta.title
useHead({
  title: `${title} | Geotur`,
})
</script>